// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useSearchParams } from 'react-router-dom';
// import {
//     Avatar,
//     Box,
//     CircularProgress,
//     Container,
//     Grid,
//     Typography,
//     Paper,
//     useTheme
// } from '@mui/material';
// import Header1 from '../Header/Header1';
// import Footer2 from '../Footer/Footer2';

// const API_URL = process.env.REACT_APP_API_URL;

// const ExpertProfilePage = () => {
//     const theme = useTheme(); // Access current theme (light/dark)
//     const [searchParams] = useSearchParams();
//     const expertId = searchParams.get('expert_id');
//     const [profile, setProfile] = useState(null);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const fetchProfile = async () => {
//             if (!expertId) return;

//             try {
//                 const response = await axios.get(`${API_URL}/api/expert-profile/?user_id=${expertId}`);
//                 setProfile(response.data);
//             } catch (error) {
//                 console.error('Error fetching expert profile:', error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchProfile();
//     }, [expertId]);

//     if (loading) {
//         return (
//             <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
//                 <CircularProgress />
//             </Box>
//         );
//     }

//     if (!profile || !profile.user) {
//         return (
//             <Typography variant="h6" align="center" color="error" sx={{ mt: 4 }}>
//                 Expert profile not found or not approved.
//             </Typography>
//         );
//     }

//     const { user, designation, areas_of_expertise, about } = profile;

//     const isDark = theme.palette.mode === 'dark';
//     const paperBg = isDark ? '#111111' : '#ffffff';
//     const pageBg = isDark ? '#000000ff' : '#f4f6f8';
//     const textPrimary = theme.palette.text.primary;
//     const textSecondary = theme.palette.text.secondary;

//     return (
//         <Box sx={{ backgroundColor: pageBg, minHeight: '100vh' }}>
//             <Header1 />

//             <Typography
//                             variant="h3"
//                             component="h1"
//                             align="center"
//                             fontSize={{ xs: '2rem', sm: '2.5rem', md: '3rem' }}
//                             sx={{
//                               backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
//                               mt: 5,
//                               letterSpacing: 7,
//                               WebkitBackgroundClip: 'text',  // This makes the gradient clip to the text
//                               color: 'transparent',  // Makes the text itself transparent to show the gradient
//                             }}
//                             gutterBottom
//                           >
//                             Expert Profile
//                           </Typography>

//             <Container maxWidth="md" sx={{ py: { xs: 4, md: 6 } }}>
//                 <Paper
//                     elevation={4}
//                     sx={{
//                         borderRadius: 4,
//                         p: { xs: 3, md: 5 },
//                         backgroundColor: paperBg,
//                         color: textPrimary,
//                     }}
//                 >
//                     <Grid container spacing={4} justifyContent="center">
//                         <Grid item xs={12} md={4} display="flex" justifyContent="center">
//                             <Avatar
//                                 src={user.image || '/default-avatar.png'}
//                                 alt={`${user.name} ${user.surname}`}
//                                 sx={{
//                                     width: { xs: 100, sm: 130, md: 160 },
//                                     height: { xs: 100, sm: 130, md: 160 },
//                                     boxShadow: 3
//                                 }}
//                             />
//                         </Grid>

//                         <Grid item xs={12} md={8}>
//   <Typography
//     variant="h4"
//     fontWeight={700}
//     gutterBottom
//     sx={{
//       textAlign: { xs: 'center', md: 'left' },
//       fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
//       letterSpacing: '0.07em',
//       textTransform: 'capitalize',
//       color: textPrimary,
//       lineHeight: 1.2,
//     }}
//   >
//     {user.name} {user.surname}
//   </Typography>

//   <Typography
//     variant="subtitle1"
//     color={textSecondary}
//     gutterBottom
//     sx={{
//       textAlign: { xs: 'center', md: 'left' },
//       fontWeight: 500,
//       fontStyle: 'italic',
//       fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
//       letterSpacing: '0.04em',
//       mb: 2,
//     }}
//   >
//     {designation}
//   </Typography>

//   <Box mt={3}>
//     <Typography
//       variant="h6"
//       color="primary"
//       fontWeight={600}
//       gutterBottom
//       sx={{
//         textTransform: 'uppercase',
//         letterSpacing: '0.1em',
//         fontFamily: "'Montserrat', sans-serif",
//       }}
//     >
//       Areas of Expertise
//     </Typography>
//     <Typography
//       variant="body1"
//       color={textPrimary}
//       sx={{ lineHeight: 1.6, fontSize: '1rem', fontFamily: "'Open Sans', sans-serif", letterSpacing: '0.1em', }}
//     >
//       {areas_of_expertise}
//     </Typography>
//   </Box>

//   <Box mt={3}>
//     <Typography
//       variant="h6"
//       color="primary"
//       fontWeight={600}
//       gutterBottom
//       sx={{
//         textTransform: 'uppercase',
//         letterSpacing: '0.1em',
//         fontFamily: "'Montserrat', sans-serif",
//       }}
//     >
//       About
//     </Typography>
//     <Typography
//       variant="body1"
//       color={textPrimary}
//       sx={{ lineHeight: 1.6, fontSize: '1rem', fontFamily: "'Open Sans', sans-serif", letterSpacing: '0.1em', }}
//     >
//       {about}
//     </Typography>
//   </Box>
// </Grid>

//                     </Grid>
//                 </Paper>
//             </Container>

//             <Footer2 />
//         </Box>
//     );
// };

// export default ExpertProfilePage;

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import {
    Avatar,
    Box,
    CircularProgress,
    Container,
    Grid,
    Typography,
    Paper,
    Button,
    useTheme
} from '@mui/material';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';
import BookingModal from '../Chatbot/BookingModel';  // ✅ import — adjust path if needed
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const API_URL = process.env.REACT_APP_API_URL;

const ExpertProfilePage = () => {
    const theme = useTheme();
    const [searchParams] = useSearchParams();
    const expertId = searchParams.get('expert_id');
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [bookingOpen, setBookingOpen] = useState(false);  // ✅ modal state

    useEffect(() => {
        const fetchProfile = async () => {
            if (!expertId) return;
            try {
                const response = await axios.get(`${API_URL}/api/expert-profile/?user_id=${expertId}`);
                setProfile(response.data);
            } catch (error) {
                console.error('Error fetching expert profile:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, [expertId]);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (!profile || !profile.user) {
        return (
            <Typography variant="h6" align="center" color="error" sx={{ mt: 4 }}>
                Expert profile not found or not approved.
            </Typography>
        );
    }

    const { user, designation, areas_of_expertise, about } = profile;

    // ✅ Build expert object for BookingModal
    const expertForBooking = {
        id: profile.expert_id,                              // expert primary key from backend
        name: `${user.name} ${user.surname}`,
        title: designation,
        expertise: areas_of_expertise?.split(',').map(s => s.trim()) || [],
        consultation_fee: profile.consultation_fee  ,
    };

    const isDark = theme.palette.mode === 'dark';
    const paperBg = isDark ? '#111111' : '#ffffff';
    const pageBg = isDark ? '#000000ff' : '#f4f6f8';
    const textPrimary = theme.palette.text.primary;
    const textSecondary = theme.palette.text.secondary;

    return (
        <Box sx={{ backgroundColor: pageBg, minHeight: '100vh' }}>
            <Header1 />

            <Typography
                variant="h3"
                component="h1"
                align="center"
                fontSize={{ xs: '2rem', sm: '2.5rem', md: '3rem' }}
                sx={{
                    backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
                    mt: 5,
                    letterSpacing: 7,
                    WebkitBackgroundClip: 'text',
                    color: 'transparent',
                }}
                gutterBottom
            >
                Expert Profile
            </Typography>

            <Container maxWidth="md" sx={{ py: { xs: 4, md: 6 } }}>
                <Paper
                    elevation={4}
                    sx={{
                        borderRadius: 4,
                        p: { xs: 3, md: 5 },
                        backgroundColor: paperBg,
                        color: textPrimary,
                    }}
                >
                    <Grid container spacing={4} justifyContent="center">
                        <Grid item xs={12} md={4} display="flex" justifyContent="center">
                            <Avatar
                                src={user.image || '/default-avatar.png'}
                                alt={`${user.name} ${user.surname}`}
                                sx={{
                                    width: { xs: 100, sm: 130, md: 160 },
                                    height: { xs: 100, sm: 130, md: 160 },
                                    boxShadow: 3
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={8}>
                            <Typography
                                variant="h4"
                                fontWeight={700}
                                gutterBottom
                                sx={{
                                    textAlign: { xs: 'center', md: 'left' },
                                    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
                                    letterSpacing: '0.07em',
                                    textTransform: 'capitalize',
                                    color: textPrimary,
                                    lineHeight: 1.2,
                                }}
                            >
                                {user.name} {user.surname}
                            </Typography>

                            <Typography
                                variant="subtitle1"
                                color={textSecondary}
                                gutterBottom
                                sx={{
                                    textAlign: { xs: 'center', md: 'left' },
                                    fontWeight: 500,
                                    fontStyle: 'italic',
                                    letterSpacing: '0.04em',
                                    mb: 2,
                                }}
                            >
                                {designation}
                            </Typography>

                            <Box mt={3}>
                                <Typography
                                    variant="h6"
                                    color="primary"
                                    fontWeight={600}
                                    gutterBottom
                                    sx={{ textTransform: 'uppercase', letterSpacing: '0.1em' }}
                                >
                                    Areas of Expertise
                                </Typography>
                                <Typography variant="body1" color={textPrimary} sx={{ lineHeight: 1.6 }}>
                                    {areas_of_expertise}
                                </Typography>
                            </Box>

                            <Box mt={3}>
                                <Typography
                                    variant="h6"
                                    color="primary"
                                    fontWeight={600}
                                    gutterBottom
                                    sx={{ textTransform: 'uppercase', letterSpacing: '0.1em' }}
                                >
                                    About
                                </Typography>
                                <Typography variant="body1" color={textPrimary} sx={{ lineHeight: 1.6 }}>
                                    {about}
                                </Typography>
                            </Box>

                            {/* ✅ Book Session Button */}
                            <Box mt={4}>
                                <Button
                                    variant="contained"
                                    size="large"
                                    fullWidth
                                    startIcon={<CalendarMonthIcon />}
                                    onClick={() => setBookingOpen(true)}
                                    sx={{
                                        py: 1.5,
                                        borderRadius: '12px',
                                        fontWeight: 700,
                                        fontSize: '1rem',
                                        background: 'linear-gradient(90deg, #2b8cff, #4da3ff)',
                                        boxShadow: '0 4px 20px rgba(43,140,255,0.4)',
                                        '&:hover': {
                                            background: 'linear-gradient(90deg, #1f6ed4, #2b8cff)',
                                            boxShadow: '0 6px 24px rgba(43,140,255,0.6)',
                                        }
                                    }}
                                >
                                    Book a Session
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            </Container>

            <Footer2 />

            {/* ✅ BookingModal — same as chatbot */}
            <BookingModal
                open={bookingOpen}
                onClose={() => setBookingOpen(false)}
                expert={expertForBooking}
                onBookSuccess={(result) => {
                    console.log('Booking successful:', result);
                    setBookingOpen(false);
                }}
            />
        </Box>
    );
};

export default ExpertProfilePage;